module.exports = __webpack_public_path__ + "img/gpt-show.5a5238ef.gif";